<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  head: {
    titleTemplate: title => title ? `${title} - MPS Expert` : 'MPS Expert',
    meta: [
      { property: 'fb:app_id', content: '460997341357161' }
    ]
  },
  mounted () {
    const url = new URL(window.location.href)
    const refCode = url.searchParams.get('ref_code')
    if (refCode) {
      window.sessionStorage.setItem('ref_code', refCode)
    }
  }
}
</script>
<style lang="scss">
@import '@/assets/styles/app.scss';
</style>
